// Debug environment variables


const isDevelopment = process.env.NODE_ENV === "development";
const productionUrl = "https://craft-classes-backend.onrender.com";
const developmentUrl = "http://localhost:3000";

export const API_URL = productionUrl;

